var map = {
	"./skin1/btn_price_tag@3x.png": "6582",
	"./skin2/btn_price_tag@3x.png": "85e1",
	"./skin3/btn_price_tag@3x.png": "9633",
	"./skin4/btn_price_tag@3x.png": "0601",
	"./skin5/btn_price_tag@3x.png": "563d",
	"./skin6/btn_price_tag@3x.png": "e7e8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ff33";